import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {ProcedureType, StudyType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {CreateStudyModalOptionalParams} from 'studies/sidepanel/NewStudyDropdown';
import {
  AssayDevelopmentStudyState,
  StudySchema,
  TypedStudyAdapter,
} from 'studies/typed/utils/TypedStudyTypes';

import MultiProcedureRunAndPlanOverviewTabContents from '../shared/MultiProcedureRunAndPlanOverviewTabContents';
import ProcedureRunAndPlanOverview from '../shared/ProcedureRunAndPlanOverview';

export const AssayDevelopmentStudyAdapter: TypedStudyAdapter<never, AssayDevelopmentStudyState> = {
  type: StudyType.ASSAY_DEVELOPMENT,

  procedureType: ProcedureType.ASSAY,

  isMultiProcedureRunEnabled: true,

  isMultiBatchEnabled: false,

  isMultiConditionEnabled: true,

  isNotificationSchedulesEnabled: false,

  isUnitOperationInstanceLinkingEnabled: true,

  isVisualizationEnabled: true,

  isOOTBChartingEnabled: false,

  maxRunsPerStudy: () => BenchlingConfig.STUDIES_MAX_NUM_EXPERIMENTS_PER_ASSAY_DEV_STUDY,

  allowReturnToDesignPhase: false,

  allowRequireDesignApproval: false,

  renderMetadataSection(_state: AssayDevelopmentStudyState) {
    return <></>;
  },

  useTypedStudyState(this: void, studySchema: StudySchema, initialValues: CreateStudyModalOptionalParams) {
    return {experimentParam: null};
  },

  getPerformanceMetadata(state: AssayDevelopmentStudyState) {
    return {};
  },

  getAnalyticsMetadata(state: AssayDevelopmentStudyState) {
    return {};
  },
  creation: {},
  design: {
    ui: {
      tab: null,
    },
  },
  overview: {
    ui: {
      tab: MultiProcedureRunAndPlanOverviewTabContents,
      design: null,
      execution: ProcedureRunAndPlanOverview,
    },
  },
  review: {},
};
